import { inject, injectable } from "inversify";

import SERVICE_IDENTIFIER from "../../constants/identifiers";

import LoadingScreen from "../../loader/LoadingScreen";
import FontPreloader from "../../loader/FontPreloader";
import IAudio from "../IAudio";
import BaseLoader from "../../loader/BaseLoader";
import { main_phaser } from "./MadnesApp";
import { madnes_adapter } from "./madnes_variables";

import {
    madnes_load_atlas,
    madnes_load_audio,
    madnes_load_bitmap_font,
    madnes_load_image,
    madnes_load_json,
} from "./madnes_loader";
import * as MV from "./madnes_variables";
import { MADNES_CONFIG } from "./madnes";
import IDOM from "../../ui/IDOM";

@injectable()
export default class MadnesLoader extends BaseLoader {
    private _loading: LoadingScreen;
    private _audio: IAudio;

    constructor(
        @inject(SERVICE_IDENTIFIER.LoadingScreen) loadingScreen: LoadingScreen,
        @inject(SERVICE_IDENTIFIER.FontPreloader) fontPreloader: FontPreloader,
        @inject(SERVICE_IDENTIFIER.EngineAudio) audio: IAudio,
        @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
    ) {
        super(loadingScreen, fontPreloader, dom);
        this.loadingScreen.updateMultiple("framework", 0, 0.9);

        this._loading = loadingScreen;
        this._audio = audio;
    }

    phaserPreload() {
        main_phaser.load.crossOrigin = "anonymous";

        this._loading.start();

        // main_phaser.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
        // main_phaser.scale.pageAlignHorizontally = true;
        // main_phaser.scale.pageAlignVertically = true;
    }

    phaserCreate() {
        main_phaser.stage.backgroundColor = "#000000";
        main_phaser.stage.disableVisibilityChange = true;

        const resourceProgressMap = new Map<
            string,
            { perc: number; chunk: number }
        >();

        let totalFiles;

        main_phaser.load.onLoadStart.add((...rest) => {
            totalFiles = main_phaser.load.totalQueuedFiles();
        });

        main_phaser.load.onFileProgress.add((res) => {
            if (res.loaded === res.total) {
                return;
            }
            if (totalFiles === 0 || res.total === 0) {
                return;
            }
            resourceProgressMap.set(res.url, {
                perc: (res.loaded / res.total) * 100,
                chunk: 100 / totalFiles,
            });

            let totalProgress = 0;
            resourceProgressMap.forEach((value) => {
                totalProgress += (value.perc / 100) * value.chunk;
            });

            this.loadingScreen.updateMultiple("framework", totalProgress, 0.9);
        });

        main_phaser.load.onFileComplete.add((_, key) => {
            resourceProgressMap.set(key, {
                perc: 100,
                chunk: 100 / totalFiles,
            });
            let totalProgress = 0;
            resourceProgressMap.forEach((value) => {
                totalProgress += (value.perc / 100) * value.chunk;
            });
            this.loadingScreen.updateMultiple("framework", totalProgress, 0.9);
        });
    }

    _loadAssets() {
        let json = madnes_adapter.to_load_json;
        for (let key in json) {
            madnes_load_json(key, json[key]);
        }

        let madnesAudio = MV.to_load_audio_madnes;
        for (let key in madnesAudio) {
            madnes_load_audio(key, madnesAudio[key]);
        }

        let audio = madnes_adapter.to_load_audio;
        for (let key in audio) {
            madnes_load_audio(key, audio[key]);
        }

        let images = madnes_adapter.to_load;
        for (let key in images) {
            madnes_load_image(key, images[key]);
        }

        let atlases = madnes_adapter.to_load_json_atlas;
        for (let key in atlases) {
            madnes_load_atlas(key, atlases[key][0], atlases[key][1]);
        }

        let bitmapFonts = madnes_adapter.to_load_fonts;
        for (let key in bitmapFonts) {
            let font = bitmapFonts[key];
            madnes_load_bitmap_font(key, font.img, font.xml);
        }

        if (MV.config_load_symbols) {
            for (let symbolName of MV.picture_convert) {
                if (!symbolName) continue; //todo refactor MV.picture_convert

                let path = MADNES_CONFIG.paths.symbols + symbolName + "/";

                madnes_load_image(
                    symbolName,
                    path + symbolName + "_sprite_{q}.png"
                );

                if (!MV.disable_load_blur) {
                    madnes_load_image(
                        symbolName + "_blur",
                        path + symbolName + "_blur_{q}.png"
                    );
                }
            }
        }
    }

    async load() {
        return new Promise<void>((res) => {
            this._loadAssets();

            main_phaser.load.onLoadComplete.add(() => {
                this._loading.updateMultiple("framework", 100, 0.9);
                res();
            });

            main_phaser.load.start();
        });
    }

    loadComplete(data) {
        main_phaser.forceSingleUpdate = true;
        // main_phaser.antialias = false;
        // main_phaser.stage.smoothed = false;

        main_phaser.gameResumed({});

        this._audio.loadComplete(data);
    }
}
